/*
 * Sale 页脚本（PG-SALE-1020-A）
 * 1. 折扣码复制：Copy → Copied（默认 2 秒后恢复）
 * 1b. 商品卡折扣码徽章（PG-CARD-BADGE-1027）：点击复制 + 图标变 ✓ + 现价数字滚动到折后价（data-price-to）
 * 2. 锚点平滑滚动：[data-pg-sale-scroll]（类目卡 / SALE 浮条），扣除 --pg-sale-scroll-offset
 * 3. 商品卡加购（[data-pg-sale-add]，PG-SALE-1020-B）
 * 4. <pg-sale-carousel>：手机端横滑 + 圆点，供 Sale 页所有「带圆点就是横滑」的模块复用
 * 5. FAQ 背景盒高度冻结（PG-SALE-1020-R5）：把模块「收起态」高度写到 --pg-sale-faq-bg-h，开合时背景图盒不变
 * 6. 首屏折扣条等比收缩（PG-SALE-1022-R10）：手机端文案 / 折扣码一行放不下时整体调小，不冲出左右内边距
 * 多个 section 会各自引入本脚本，用全局闸防重复执行。
 */
(function () {
  'use strict';
  if (window.__pgSaleInit) return;
  window.__pgSaleInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- 1. 复制 ---------- */
  function fallbackCopy(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
    document.body.appendChild(area);
    area.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(area);
    return ok;
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(function () { return true; }, function () { return fallbackCopy(text); });
    }
    return Promise.resolve(fallbackCopy(text));
  }

  function onCopyClick(button) {
    var code = button.getAttribute('data-code') || '';
    var label = button.querySelector('.pg-sale-offer__copy-label');
    if (!code || !label) return;
    copyText(code).then(function (ok) {
      // 复制成功显示「已复制」；clipboard 与 execCommand 都失败时显示可配的失败文案（R1，冷评审 #23），同样 ms 后恢复
      label.textContent = ok ? (button.getAttribute('data-label-copied') || 'Copied') : (button.getAttribute('data-label-failed') || 'Copy failed');
      button.classList.toggle('is-copied', ok);
      clearTimeout(button.__pgSaleTimer);
      var ms = parseInt(button.getAttribute('data-reset-ms'), 10) || 2000;
      button.__pgSaleTimer = setTimeout(function () {
        label.textContent = button.getAttribute('data-label-copy') || 'Copy';
        button.classList.remove('is-copied');
      }, ms);
    });
  }

  /* ---------- 1b. 商品卡折扣码徽章（PG-CARD-BADGE-1027） ---------- */
  var BADGE_FLASH_MS = 1500; // ✓ 图标 / 提示文案保持时长
  var PRICE_ROLL_MS = 800; // 现价数字滚动时长

  function moneyFormatter() {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency });
    } catch (e) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    }
  }

  // 把元素当前显示的金额文字解析成分；解析不了回退到服务端写的原价（data-pg-price-now，分）
  function displayedCents(el) {
    var n = parseFloat((el.textContent || '').replace(/[^0-9.]/g, ''));
    if (!isNaN(n)) return Math.round(n * 100);
    return parseInt(el.getAttribute('data-pg-price-now'), 10) || 0;
  }

  // 现价从当前显示值递减滚动到折后价（分）：easeOutCubic，结束时写入严格等于格式化后的折后价并标记已应用
  function rollPrice(el, toCents) {
    if (el.getAttribute('data-pg-price-applied') === String(toCents)) return; // 已经是这个折后价：重复点击只复制
    if (el.__pgRollRaf) { cancelAnimationFrame(el.__pgRollRaf); el.__pgRollRaf = 0; }
    var fmt = moneyFormatter();
    var finish = function () {
      el.textContent = fmt.format(toCents / 100);
      el.setAttribute('data-pg-price-applied', String(toCents));
      el.__pgRollRaf = 0;
    };
    var fromCents = displayedCents(el);
    if (reduceMotion.matches || fromCents === toCents) { finish(); return; }
    var start = null;
    var step = function (now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / PRICE_ROLL_MS);
      if (t >= 1) { finish(); return; }
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt.format(Math.round(fromCents + (toCents - fromCents) * eased) / 100);
      el.__pgRollRaf = requestAnimationFrame(step);
    };
    el.__pgRollRaf = requestAnimationFrame(step);
  }

  function onBadgeClick(badge) {
    var code = badge.getAttribute('data-code') || '';
    if (!code) return;
    if (badge.__pgLabel === undefined) badge.__pgLabel = badge.getAttribute('aria-label') || '';
    // 折后价动画与复制结果无关（复制失败也让买家看到折后价），所以点击当下就开始
    var toCents = parseInt(badge.getAttribute('data-price-to'), 10);
    var card = badge.closest('[data-pg-sale-card]');
    var priceNow = card && card.querySelector('[data-pg-price-now]');
    if (toCents > 0 && priceNow) rollPrice(priceNow, toCents);
    copyText(code).then(function (ok) {
      badge.setAttribute('aria-label', ok ? (badge.getAttribute('data-label-copied') || 'Copied') : (badge.getAttribute('data-label-failed') || 'Copy failed'));
      badge.classList.toggle('is-copied', ok);
      clearTimeout(badge.__pgBadgeTimer);
      badge.__pgBadgeTimer = setTimeout(function () {
        badge.classList.remove('is-copied');
        badge.setAttribute('aria-label', badge.__pgLabel);
      }, BADGE_FLASH_MS);
    });
  }

  /* ---------- 2. 锚点平滑滚动 ---------- */
  function scrollOffset(from) {
    var raw = window.getComputedStyle(from).getPropertyValue('--pg-sale-scroll-offset');
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : n;
  }

  function scrollToTarget(link, event) {
    var hash = link.getAttribute('href') || '';
    if (hash.charAt(0) !== '#' || hash.length < 2) return;
    var id = decodeURIComponent(hash.slice(1));
    var target = document.getElementById(id);
    if (!target) return; // 目标模块还不存在时保持浏览器默认行为（不拦截）
    event.preventDefault();
    var rect = target.getBoundingClientRect();
    var top;
    if (link.getAttribute('data-pg-sale-scroll-block') === 'center') {
      top = window.pageYOffset + rect.top + rect.height / 2 - window.innerHeight / 2;
    } else {
      // 偏移取目标自带的 --pg-sale-scroll-offset（类目模块：PC 70 / 手机 56 = 常驻 header 44 + 余量 12，随断点变）
      top = window.pageYOffset + rect.top - scrollOffset(target);
    }
    window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    if (window.history && history.replaceState) {
      try { history.replaceState(null, '', '#' + id); } catch (e) { /* 忽略 */ }
    }
  }

  document.addEventListener('click', function (event) {
    var copy = event.target.closest && event.target.closest('[data-pg-sale-copy]');
    if (copy) { onCopyClick(copy); return; }
    var badge = event.target.closest && event.target.closest('[data-pg-coupon-badge]');
    if (badge) { onBadgeClick(badge); return; }
    var link = event.target.closest && event.target.closest('[data-pg-sale-scroll]');
    if (link) scrollToTarget(link, event);
  });

  /* ---------- 3. 商品卡加购（与集合页同款：请求 /cart/add.js 后交给 cart-drawer / cart-notification 渲染） ---------- */
  function addToCart(form) {
    var button = form.querySelector('[type="submit"]');
    // 错误提示在卡内正常流（.pg-sale-card__buy 里、表单之后），不在 form 内
    var card = form.closest('[data-pg-sale-card]');
    var error = (card || form).querySelector('[role="alert"]');
    // 请求中以 aria-busy 拦截重复点击；不用 disabled（会命中 .pg-cv2-button:disabled 的 opacity .45，加载态变淡）
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = new FormData(form);
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 15000);
    // 失败一律显示可配兜底文案（section 设置 add_error_text），不展示 JSON 解析报错 / 接口技术文案（R1，视觉 QA D3）
    var fallbackText = form.getAttribute('data-error-text') || 'Something went wrong. Please try again.';
    if (error) error.hidden = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading', 'is-active');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    if (cart) {
      // 主题购物车抽屉接口同步抛错时不能让 aria-busy 卡住：退回「加购后跳购物车页」路径（R3，增量评审第 5 条）
      try {
        body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        body.append('sections_url', location.pathname);
        cart.setActiveElement(button);
      } catch (e) {
        body.delete('sections');
        body.delete('sections_url');
        cart = null;
      }
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', { method: 'POST', body: body, signal: controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } })
      // 非 JSON（429 / 网关 HTML 错误页）时 json() 会抛 SyntaxError：吞掉，统一按失败走兜底文案
      .then(function (res) { return res.json().catch(function () { return null; }).then(function (data) { return { res: res, data: data }; }); })
      .then(function (r) {
        if (!r.res.ok || !r.data || r.data.status) throw new Error(fallbackText);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: body.get('id'), cartData: r.data });
        }
        if (cart) {
          cart.renderContents(r.data);
          cart.classList.remove('is-empty');
          if (typeof setFooterCart === 'function') setFooterCart();
        } else location.assign((window.routes && window.routes.cart_url) || '/cart');
      })
      .catch(function () {
        if (error) { error.textContent = fallbackText; error.hidden = false; }
      })
      .then(function () {
        clearTimeout(timer);
        button.classList.remove('loading', 'is-active');
        button.removeAttribute('aria-busy');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-pg-sale-add]');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });

  /* ---------- 4. 横滑 + 圆点组件 ---------- */
  // 不能用 return 提前退出：否则第 5 节 FAQ 冻结在无 customElements 或组件已注册时会整体不执行（架构师复核发现，R7 修正）
  if (window.customElements && !customElements.get('pg-sale-carousel')) {
    customElements.define('pg-sale-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pg-sale-track]');
        this.dotsHost = this.querySelector('[data-pg-sale-dots]');
        if (!this.track || !this.dotsHost) return;
        this.build();
        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.mark(0);
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }

      items() {
        return Array.prototype.slice.call(this.track.children);
      }

      // 圆点读屏文案：来自 section 设置 dot_label（data-dot-label，{n} 换成页码；没写 {n} 则页码追加在末尾）
      dotLabel(n) {
        var tpl = this.getAttribute('data-dot-label') || 'Go to slide {n}';
        return tpl.indexOf('{n}') > -1 ? tpl.replace('{n}', n) : tpl + ' ' + n;
      }

      build() {
        var self = this;
        var items = this.items();
        this.dotsHost.innerHTML = '';
        this.dots = items.map(function (item, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pg-sale-dot';
          dot.setAttribute('aria-label', self.dotLabel(i + 1));
          dot.addEventListener('click', function () { self.go(i); });
          self.dotsHost.appendChild(dot);
          return dot;
        });
        // 只有 1 页时不需要圆点
        this.dotsHost.hidden = items.length < 2;
      }

      go(index) {
        var item = this.items()[index];
        if (!item) return;
        var left = item.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
        this.track.scrollTo({ left: left, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        var self = this;
        requestAnimationFrame(function () {
          self.ticking = false;
          var trackLeft = self.track.getBoundingClientRect().left;
          var best = 0;
          var bestDist = Infinity;
          self.items().forEach(function (item, i) {
            var dist = Math.abs(item.getBoundingClientRect().left - trackLeft);
            if (dist < bestDist) { bestDist = dist; best = i; }
          });
          self.mark(best);
        });
      }

      mark(index) {
        if (!this.dots) return;
        this.dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      }
    });
  }

  /* ---------- 5. FAQ 背景盒高度冻结（PG-SALE-1020-R5） ---------- */
  // 平板（560~959）与运营自传手机图的背景盒高 = 模块收起态高度（见 pg-sale-lower.css）。
  // 收起高度 = 模块当前高 − 展开多出的高度：每个 open 的 <details> 比收起态多出「答案区」，
  // 加上展开态 :has(open) 下模块底 / 面板上下 padding 比收起态多出的部分。开合时这个值不变，视口宽变化（换行变化）时随之更新。
  function px(value) { return parseFloat(value) || 0; }

  function faqCollapsedHeight(section) {
    var cs = getComputedStyle(section);
    var total = section.offsetHeight;
    // 模块底 padding：当前值 − 收起态值（变量由 CSS 提供，PC 无此变量时按 0 处理）
    var closedPb = px(cs.getPropertyValue('--pg-sale-faq-pb-closed'));
    if (!closedPb) return 0; // 变量只在 ≤959 定义；PC 不用冻结盒，不写变量
    total -= Math.max(0, px(cs.paddingBottom) - closedPb);
    // 面板上下 padding：当前值 − 收起态值
    var panel = section.querySelector('.pg-sale-faq__panel');
    var closedPy = px(cs.getPropertyValue('--pg-sale-faq-panel-py-closed'));
    if (panel && closedPy) {
      var ps = getComputedStyle(panel);
      total -= Math.max(0, px(ps.paddingTop) + px(ps.paddingBottom) - closedPy * 2);
    }
    // 每个展开项：整项高 − 收起态整项高（summary + 自身 padding / border）= 答案区（含 margin）
    section.querySelectorAll('.pg-sale-faq__item[open]').forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary) return;
      var is = getComputedStyle(item);
      var closed = summary.offsetHeight + px(is.paddingTop) + px(is.paddingBottom) + px(is.borderTopWidth) + px(is.borderBottomWidth);
      total -= Math.max(0, item.offsetHeight - closed);
    });
    return Math.round(total);
  }

  function syncFaqBgHeight(section) {
    var h = faqCollapsedHeight(section);
    if (h > 0 && section.__pgSaleFaqH !== h) {
      section.__pgSaleFaqH = h;
      section.style.setProperty('--pg-sale-faq-bg-h', h + 'px');
    }
  }

  // 首次观察一个 FAQ 模块：打标记，同一模块只挂一次 ResizeObserver / 监听（重复调用安全）
  function watchFaq(section) {
    if (section.__pgSaleFaqWatched) return;
    section.__pgSaleFaqWatched = true;
    syncFaqBgHeight(section);
    if (window.ResizeObserver) {
      new ResizeObserver(function () { syncFaqBgHeight(section); }).observe(section);
    } else {
      // 旧浏览器没有 ResizeObserver：退回到窗口缩放 + 开合事件
      window.addEventListener('resize', function () { syncFaqBgHeight(section); });
      section.addEventListener('toggle', function () { syncFaqBgHeight(section); }, true);
    }
  }

  document.querySelectorAll('.pg-sale-faq').forEach(watchFaq);

  /* ---------- 6. 首屏折扣条等比收缩（PG-SALE-1022-R10） ---------- */
  // 手机稿折扣条 343 宽按「EXTRA 15% OFF / YEAREND15」排版；运营换成更长的文案或折扣码时一行放不下，
  // 内容会吃掉左右内边距甚至溢出首屏。条内尺寸全按 em 写（见 pg-sale.css），放不下时按比例调小 --pg-sale-offer-u 整体等比缩，放得下保持稿值。
  // PC 折扣条是 inline-flex、宽度随内容，不需要收缩。
  function fitOffer(offer) {
    offer.style.removeProperty('--pg-sale-offer-u');
    var cs = getComputedStyle(offer);
    if (cs.display !== 'flex') return;
    var avail = offer.clientWidth - px(cs.paddingLeft) - px(cs.paddingRight) - 1; // 留 1px 防亚像素取整溢出
    var kids = offer.children;
    var need = px(cs.columnGap) * Math.max(0, kids.length - 1);
    for (var i = 0; i < kids.length; i++) need += kids[i].getBoundingClientRect().width;
    if (need > avail && avail > 0) {
      offer.style.setProperty('--pg-sale-offer-u', Math.floor(px(cs.fontSize) * avail / need * 100) / 100 + 'px');
    }
  }

  function fitOffers(root) {
    (root || document).querySelectorAll('.pg-sale-offer').forEach(fitOffer);
  }

  fitOffers();
  // Roboto 晚于脚本加载时字宽会变，字体就绪后再量一次
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitOffers(); });
  var fitFrame = 0;
  window.addEventListener('resize', function () {
    cancelAnimationFrame(fitFrame);
    fitFrame = requestAnimationFrame(function () { fitOffers(); });
  });

  // 主题编辑器重载区块后，新 DOM 需要重新观察（R5 评审 P2-3）；改折扣条文案 / 折扣码也走这里重新收缩
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelectorAll) return;
    if (root.classList && root.classList.contains('pg-sale-faq')) watchFaq(root);
    root.querySelectorAll('.pg-sale-faq').forEach(watchFaq);
    fitOffers(root);
  });
})();
